import { SearchResultSkeletonRow } from "./SearchResultSkeletonRow";

const SKELETON_ROW_KEYS = [
  "skeleton-1",
  "skeleton-2",
  "skeleton-3",
  "skeleton-4",
  "skeleton-5",
  "skeleton-6",
];

export const SearchResultsSkeleton = () => (
  <>
    {SKELETON_ROW_KEYS.map(key => (
      <SearchResultSkeletonRow key={key} />
    ))}
  </>
);
